import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa";

export default function FooterSection() {
  return (
    <>
      {/* ================= ORANGE SECTION ================= */}
        <section className="bg-[#FF6f3c] text-white pt-10 md:pt-14 lg:pt-16 pb-40 md:pb-40 lg:pb-40">   
         <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-6 md:gap-8 items-center">
          
          {/* Left Content */}
          <header>
        <h2 className="text-3xl md:text-4xl font-bold leading-snug text-black">         
         Subscribe for latest <br /> news & updates
            </h2>

            <p className="mt-3 text-base md:text-lg text-black max-w-md">
              Stay updated with our latest services, insights, and company news.
              We share only meaningful updates—no spam.
            </p>
          </header>

          {/* Right Form */}
          <form
            className="w-full max-w-md mx-auto md:ml-auto"
            onSubmit={(e) => e.preventDefault()}
          >
            <label htmlFor="email" className="sr-only">
              Email address
            </label>

            <input
              id="email"
              type="email"
              required
              placeholder="Enter your email address"
            className="w-full h-11 md:h-12 px-4 rounded-full border border-white bg-transparent placeholder-white focus:outline-none focus:ring-2 focus:ring-white focus:border-white"
       />

            <button
              type="submit"
              className="mt-3 w-full h-11 md:h-12 rounded-full bg-white text-orange-700 font-semibold hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-orange-500 transition"
            >
              Subscribe
            </button>
          </form>
        </div>
      </section>

      {/* ================= FOOTER OVERLAP ================= */}
      <div className="relative max-w-6xl mx-auto px-4 md:px-6 -mt-24 md:-mt-32">
        <footer className="bg-[#1f1b1a] rounded-3xl px-6 py-10 md:py-12 text-white shadow-xl">

        <div className="grid md:grid-cols-3 gap-8 md:gap-10 max-w-5xl mx-auto">            
            {/* Brand */}
            <article>
              <div className="flex items-center gap-3">
                <img
                  src="/maxzenlogo.webp"  // ✅ fixed path (see note below)
                  alt="Maxzen Logo"
                  className="w-12 h-12 object-contain"
                />

                <h3 className="text-md font-bold leading-none">
                  Maxzen HR Services Pvt. Ltd.
                </h3>
              </div>

              <p className="mt-3 text-gray-300 text-sm leading-relaxed max-w-xs">
                We help businesses grow through strategic solutions, digital
                transformation, and innovative services tailored to your needs.
              </p>

              {/* Social Icons */}
              <nav className="flex gap-3 mt-6" aria-label="Social media links">
                {[
                  { icon: FaFacebookF, name: "Facebook", href: "https://www.facebook.com/profile.php?id=61568699487730" },
                  { icon: FaInstagram, name: "Instagram", href: "https://www.instagram.com/maxzen_hr_services/" },
                  { icon: FaLinkedinIn, name: "LinkedIn", href: "https://www.linkedin.com/company/maxzen-hr-services/?viewAsMember=true" },
                  { icon: FaTwitter, name: "Twitter", href: "https://x.com/maxzenhrservice" },
                ].map(({ icon: Icon, name, href }) => (
                  <a
                    key={name}
                    href={href}
                    className="w-11 h-11 flex items-center justify-center rounded-full border border-gray-500 hover:bg-orange-500 hover:border-orange-500 transition focus:outline-none focus:ring-2 focus:ring-orange-500"
                  >
                    <Icon size={16} aria-hidden="true" />
                    <span className="sr-only">{name}</span>
                  </a>
                ))}
              </nav>
            </article>

            {/* Contact */}
            <address className="not-italic">
              <h4 className="text-lg font-semibold">Get in Touch</h4>
              <ul className="mt-4 space-y-2 text-gray-300 text-sm">
                <li>
                  <a href="mailto:info@maxzenhr.com" className="hover:text-white focus:ring-2 focus:ring-orange-500">
                    info@maxzenhr.com
                  </a>
                </li>
                <li>
                  <a href="tel:+918498989844" className="hover:text-white focus:ring-2 focus:ring-orange-500">
                    +91 84989 89844
                  </a>
                </li>
                <li>
                  14th Floor, Manjeera Trinity Corporate,
                  <br />
                   KPHB Phase 3, Hyderabad - 500072
                </li>
              </ul>
            </address>

            {/* Links */}
            <nav aria-label="Primary links">
              <h4 className="text-lg font-semibold">Quick Links</h4>
              <ul className="mt-4 space-y-2 text-gray-300 text-sm">
                <li><a href="/">Home</a></li>
                <li><a href="/services">Services</a></li>
                <li><a href="/contact">Contact</a></li>
                <li><a href="/about">About Us</a></li>
                <li><a href="/blog">Blog</a></li>
              </ul>
            </nav>
          </div>

          {/* Bottom */}
          <div className="border-t border-gray-700 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>© {new Date().getFullYear()} Maxzen HR Services Pvt. Ltd. All rights reserved.</p>

            <nav className="flex gap-6">
              <a href="/privacy-policy">Privacy Policy</a>
              <a href="/terms">Terms</a>
            </nav>
          </div>
        </footer>
      </div>
    </>
  );
}